<section>
  <h3 class="mat-headline">Learn why comments are turned off</h3>
  <p class="mat-subheading-1">Comments may be turned off across {{companyInformation.name}} because:</p>
  <ul>
    <li>The story owner selected the setting to "Disable comments."</li>
    <li>The story is a draft and has not been published yet.</li>
    <li>{{companyInformation.name}} may have turned off comments on some stories temporarily for development/testing purposes.</li>
  </ul>

  <br />
  <br />

  <h3 class="mat-title">Why might {{companyInformation.name}} turn off comments?</h3>
  <p class="mat-subheading-1">Comments on some stories may be turned off temporarily by {{companyInformation.name}} for development/testing purposes. We know comments are important to writers and readers, we will be sure to reduce as much down time as possible and let you know in advance.</p>
</section>
